import React from "react";
import { Link, useOutletContext } from "react-router-dom";
import RunInputs from "../components/RunInputs";

/**
 * Step 1 of a run that already exists.
 *
 * The inputs are stored with the run, so reopening it shows what was uploaded --
 * filenames, checksums and the mapping they were read into -- rather than the
 * empty upload form, which would invite a scientist to replace a run they only
 * meant to look at.
 */
export default function RunFilesScreen() {
  const { run } = useOutletContext();

  return (
    <>
      <div className="banner ok">
        <strong>Files already uploaded.</strong> These are the inputs this run was analysed from,
        and every number downstream is derived from them. To analyse a different set,{" "}
        <Link to="/new">start a new run</Link>.
      </div>
      <RunInputs manifest={run.manifest} mapping={run.mapping} />
    </>
  );
}
